import BundleActivity from './BundleActivity';

export default BundleActivity;
